import {
  Button,
  Input,
  SimpleGrid,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { apiurl } from "APIURL";
import axios from "axios";
import Card from "components/card/Card";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getProfileData, setProfile } from "redux/slices/userSlice";
import { Profile, User } from "types";
import Information from "views/admin/profile/components/Information";

export default function GeneralInformation(props: { [x: string]: any }) {
  const { ...rest } = props;
  const history = useHistory();
  const profile = useSelector(getProfileData);
  const [birthdate, setBirthdate] = useState(
    new Date(profile.birthdate).toDateString()
  );
  const [updateBirthDate, setUpdateBirthdate] = useState(false);
  const [email, setEmail] = useState(profile.email);
  const [updateEmail, setUpdateEmail] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(
    profile.phoneNumber.toString()
  );
  const [updatePhoneNumber, setUpdatePhoneNumber] = useState(false);
  const dispatch = useDispatch();
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const cardShadow = useColorModeValue(
    "0px 18px 40px rgba(112, 144, 176, 0.12)",
    "unset"
  );

  const handleDeactivateAccount = async () => {
    try {
      await axios.patch(`${apiurl}/user/${profile.userId}`, {
        isBlocked: true,
      });
      history.push("/auth");
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmitUpdate = async (
    event: React.FormEvent,
    id: string,
    data: Partial<User & Profile>
  ) => {
    event.preventDefault();
    try {
      const response = await axios.patch(`${apiurl}/user/updateProfile/${id}`, {
        email: data.email,
        phoneNumber: data.phoneNumber,
        birthdate: data.birthdate,
      });
      dispatch(
        setProfile({
          ...response.data.profile,
          ...response.data.user,
        })
      );
      setUpdateBirthdate(false);
      setUpdateEmail(false);
      setUpdatePhoneNumber(false);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Card mb={{ base: "0px", "2xl": "20px" }} {...rest}>
      <Text
        color={textColorPrimary}
        fontWeight="bold"
        fontSize="2xl"
        mt="10px"
        mb="4px"
      >
        Informations générales
      </Text>

      <form
        onSubmit={(e) =>
          handleSubmitUpdate(e, profile.userId, {
            email,
            phoneNumber: parseInt(phoneNumber),
            birthdate: new Date(birthdate),
          })
        }
      >
        <SimpleGrid columns={2} gap="20px">
          {!updateEmail ? (
            <Information
              onUpdate={() => setUpdateEmail(true)}
              boxShadow={cardShadow}
              title="E-mail"
              value={profile.email}
            />
          ) : (
            <Input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              isRequired={false}
              variant="auth"
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="email"
              placeholder=""
              mb="24px"
              fontWeight="500"
              size="lg"
            />
          )}
          {!updatePhoneNumber ? (
            <Information
              onUpdate={() => setUpdatePhoneNumber(true)}
              boxShadow={cardShadow}
              title="Numéro de téléphone"
              value={"+216 " + profile.phoneNumber}
            />
          ) : (
            <Input
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              isRequired={false}
              variant="auth"
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="tel"
              placeholder=""
              mb="24px"
              fontWeight="500"
              size="lg"
            />
          )}
          <Information
            onUpdate={() => {
              console.log("update");
            }}
            boxShadow={cardShadow}
            title="Fonction"
            value=""
          />
          {!updateBirthDate ? (
            <Information
              onUpdate={() => setUpdateBirthdate(true)}
              boxShadow={cardShadow}
              title="Birthday"
              value={new Date(profile.birthdate).toLocaleDateString("fr-FR", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            />
          ) : (
            <Input
              value={birthdate}
              onChange={(e) => setBirthdate(e.target.value)}
              isRequired={false}
              variant="auth"
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="date"
              placeholder="mail@example.com"
              mb="24px"
              fontWeight="500"
              size="lg"
            />
          )}

          {updateEmail || updatePhoneNumber || updateBirthDate ? (
            <Button
              type="submit"
              fontSize="sm"
              variant="brand"
              fontWeight="500"
              w="100%"
              h="50"
              mb="24px"
            >
              Validé
            </Button>
          ) : null}
        </SimpleGrid>

        <SimpleGrid>
          <Button
            onClick={handleDeactivateAccount}
            fontSize="sm"
            variant="brand"
            fontWeight="500"
            w="100%"
            h="50"
            mb="24px"
          >
            Désactiver le compte
          </Button>
        </SimpleGrid>
      </form>
    </Card>
  );
}
